import { ScopeOfWorkStep } from "./scope-of-work.types";

export const SCOPE_OF_WORK_STEPS: ScopeOfWorkStep[] = [
  ScopeOfWorkStep.Categories,
  ScopeOfWorkStep.TypeOfPlaces,
  ScopeOfWorkStep.TypeOfService,
  ScopeOfWorkStep.Areas,
  ScopeOfWorkStep.Objects,
  ScopeOfWorkStep.SpecialRequests,
];
